/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_All_B_To_AInputs */



/**
* | output |
* | --- |
* | "Apply All B → A" |
*
* @param {Compare_Event_Groups_Apply_All_B_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_all_b_to_a = /** @type {((inputs?: Compare_Event_Groups_Apply_All_B_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_All_B_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer tout B → A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle B → A anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica tutto B → A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить все B → A")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar todo B → A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部应用 B → A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて適用 B → A")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी B → A लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar tudo B → A")
	return /** @type {LocalizedString} */ ("Apply All B → A")
});